import apiFetch from '../../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Visita`, method: 'GET', body: null, token: token})
}
